import { BaSeButton, BaSeOptionPicker, BaSeTheme } from '@base/react';
import React from 'react';
import { ButtonSelectOption } from '../../pages/certificados-cliente/certificados-cliente-styled';

export const ColumnFilter = ({
  columnId,
  items,
  setFilter,
  setTags,
  closeFilter,
  fetchData,
  isSearchFor,
  setIsClearFilter,
  setListModels,
  resetSelection,
  setIsListService,
}) => {
  const [columnFilter, setColumnFilter] = React.useState([]);
  const [selectedList, setSelectedList] = React.useState([]);

  const handleChange = React.useCallback(
    (option) => {
      const list = option.map((item) => item?.label);
      setColumnFilter((actualFilter) => [
        ...actualFilter.filter((item) => {
          return item.includes(list);
        }),
        ...list,
      ]);
    },
    [setColumnFilter],
  );

  const TagLabel = React.useMemo(
    () => ({
      tipo: 'Template',
    }),
    [],
  );

  const saveSelection = React.useCallback(() => {
    setIsClearFilter(false);
    setIsListService(true);
    setFilter((actualFilter) => {
      if (!isSearchFor) {
        return fetchData({
          filter: { listaModelos: columnFilter },
        });
      }
      return { ...actualFilter, listaModelos: columnFilter };
    });
    setListModels(columnFilter);
    setTags((tagsActive) => {
      return [
        ...tagsActive.filter((tag) => !tag?.label?.startsWith('Template')),
        {
          label: `${TagLabel[columnId]}: ${columnFilter}`,
          onClose: () => {
            setTags((tags) => {
              const tagsFiltered = [
                ...tags.filter(
                  (tag) => !tag?.label?.startsWith(TagLabel[columnId]),
                ),
              ];
              setIsClearFilter(!tagsFiltered.length);
              return tagsFiltered;
            });
            setListModels('');
            fetchData({
              filter: { listaModelos: '' },
              sort: { field: 'dataConclusao', type: 'DESC' },
            });
            resetSelection();
          },
        },
      ];
    });
    resetSelection();
    closeFilter();
  }, [
    TagLabel,
    closeFilter,
    columnFilter,
    columnId,
    fetchData,
    isSearchFor,
    resetSelection,
    setFilter,
    setIsClearFilter,
    setIsListService,
    setListModels,
    setTags,
  ]);

  return (
    <>
      {
        <BaSeOptionPicker
          color={BaSeTheme.colors.institucionais.azulSebrae}
          label={TagLabel[columnId]}
          values={items}
          emptyValueLabel="Selecione"
          onChange={(e) => {
            handleChange(e);
            setSelectedList(e);
          }}
          searchPlaceholder="Pesquisar"
          maxMenuHeight="360px"
          size="medium"
          width={322}
          menuAlwaysIsOpen={true}
        />
      }
      <ButtonSelectOption>
        <BaSeButton
          isDisabled={!selectedList?.length}
          value="Selecionar"
          onClick={saveSelection}
          color={BaSeTheme.colors.institucionais.azulSebrae}
        />
      </ButtonSelectOption>
    </>
  );
};
